import styled from 'styled-components';

import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';

export const Container = styled.div<{ backgroundColor: string; textColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  padding-bottom: ${CONTAINER_PADDING * 3}px;
`;

export const HeaderWrapper = styled.div`
  padding-top: ${CONTAINER_PADDING * 3}px;
`;
